import React from "react";
import Widget from "./Widget";

function Embed() {
  return (
    <div className="min-h-screen bg-white py-8">
      <div className="max-w-4xl mx-auto px-4">
        <Widget embedded={true} />
      </div>
    </div>
  );
}

export default Embed;